import PrintPreferenceTabs from "../templete/PrintPreferenceTabs";
const PurchaseReturn = () => {
  return (
    <PrintPreferenceTabs type="purchase_return"></PrintPreferenceTabs>
  );
};
export default PurchaseReturn;


